module.exports = __webpack_public_path__ + "static/media/TransportMgmt.caeabcc9.svg";